/* global axios */
import ApiClient from '../ApiClient';

class CarShowroomAPI extends ApiClient {
  constructor() {
    super('car_showroom', { accountScoped: true, wgpt: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(formData) {
    return axios.patch(this.url, formData);
  }

  attachImage(kind, formData) {
    return axios.post(`${this.url}/images/${kind}`, formData);
  }

  removeImage(kind) {
    return axios.delete(`${this.url}/images/${kind}`);
  }

  slugAvailable(slug) {
    return axios.get(`${this.url}/slug_available`, { params: { slug } });
  }

  backgroundPresets() {
    return axios.get(`${this.url}/background_presets`);
  }

  // Same endpoint as a background upload — the server copies the bundled file
  // instead of reading an uploaded one.
  applyBackgroundPreset(presetId) {
    return axios.post(`${this.url}/images/background`, { preset_id: presetId });
  }
}

export default new CarShowroomAPI();
